import mdsRequire from 'dojo/require';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './EntityView.html?raw';
import on from 'dojo/on';
import topic from 'dojo/topic';
import _TabEnabledMixin from '../../Tabbing/_TabEnabledMixin';
import GenericDialog from '../../GenericDialog/GenericDialog';
import { ExpandableSection } from "../../Container/ExpandableSectionTypes";
import FilterPanelWidget from '../../FilterPanel/FilterPanel';
import { SelectEntityDialogTypes, SelectEntityDialog } from "../../../_loadingHelpers/SelectEntityDialog";
import Edit from '../../Edit/Edit';
import FloatingContainer from '../../Floating/FloatingContainer';
import _StatefulBase from '../../_StatefulBase/_StatefulBase';
import { ExpandableSectionMarkings } from "../../Container/ExpandableSectionTypes";
import CheckBox from '../../CheckBox/CheckBox';
import { FilterPanelTypes, FilterPanelFormat } from "../../FilterPanel/FilterPanelTypes";
import { EntityViewTypes } from "./EntityViewTypes";
import { EntityHelpers, FileHelpers, TabbingHelpers, TranslationHelpers, PermissionHelper } from "../../../../more/Helpers";
import PageStack from '../../Tabbing/PageStack';

//import GenericEntityView = require("./GenericEntityView"); // das geht ned. zirkuläre Abhängigkeit!

// (mds) filePreview now via the eager registry (mdsRequire, already imported) — breaks the EntityView->filePreview->...->EntityView ESM cycle
import { uiFrameTypes } from "../../Container/uiFrameTypes";
import _WidgetBase from 'dijit/_WidgetBase';

interface EnityFrameOptionsLEGACY<T = any> {
    requestDataFunctionname?: string,
    deleteEntityFunctionname?: string,
    entityClassname: string,
    entityClassPrintname: string,
    idProperty?: string,
    labelProperty?: string,
    additionalRequestParams?: Object
    userroleEdit?: string | Array<string>,
    userroleDelete?: string | Array<string>,
    userroleClone?: string | Array<string>,
    featurePathEdit?: string,
    featurePathClone?: string,
    featurePathDelete?: string,
    colorProperty?: string,
    nonInteractive?: boolean;
}

interface expanderState {
    name: string,
    expanded: boolean;
//    parent: string;
//    previousNeighbor: string;
//    followingNeighbor: string;
//    nested: Record<string, expanderState>
}

interface EntityViewUserSettings {
    entityID: string,
    contextname: string,
    widgetClass: string,
    expanderStates: Record<string, expanderState>
}


/**
 * Basis-Mixin für Entityviews
 * @fires change Bei Änderungen durch Entity-Actions
 * @fires deleted
 * @fires closed
 * @fires loaded
 * @fires cloned
 */
class _EntityViewMixin<X> extends compose(_TabEnabledMixin) {
    templateString: any = template;

    private filePreviewWidget: any;
    private contentContainer: HTMLElement;
    private isActive: boolean = false;
    protected entityID: string = null;
    protected entity: X;
    protected contextName: string = "default";
    protected viewData: EntityViewTypes.EntityViewResponse<X>;

    protected dlg: MdsLax<InstanceType<typeof GenericDialog>> = null;
    protected isStandalone: boolean = true;
    protected useStandaloneFrame: boolean = false;

    protected __isNonInteractiveEntityView: boolean = false;

    useDefaultButtons: boolean = true;

    groupLabel: string = null;

    protected tabContainerName: string;
    protected openEditorTab: Tabbing.TabContainerPage;
    private isEditing: boolean = false;

    private currentDisplayMode: EntityViewTypes.DisplayMode = "dlg";

    private _buttonConfigsQueue: Array<EntityViewTypes.ButtonConfig> = null;
    private _buttonConfigs: Array<EntityViewTypes.ButtonConfig> = null;

    private _contextValues: Array<EntityViewTypes.ButtonConfig> = null;

    private _isEmptyContent: boolean = true;
    protected isLoaded: boolean = false;
    private _hideIfEmpty: boolean = true;
    private _isHidden: boolean = false;
    private _hidingCallback: Function = null;

    private _expanderStateMap: Record<string, expanderState>;
    private _expanderNameIndex: Record<string, number>;

    //private contextButtons: Array<ContextButton> = [];

    protected addContent(content: dojo.NodeFragmentOrString, position?: string|number) {
        this.UiModder.domConstruct.place(content, this.contentContainer, position);
    }

    private __evEditorWidget: MdsLax<InstanceType<typeof _WidgetBase>>;

    private _onRequestEditor(entityID: string, entity) {

        if (this.dlg) this.dlg.close(-1, true);

        if (this.openEditorTab) {
            if (this.activateTab(this.openEditorTab.name) == true) {
                this.isEditing = true;
                return;
            }
        }

        if (this.isEditing == true) return;

        this.__evEditorWidget = this.onRequestEditor(this.entityID, this.entity);

        if (this.__evEditorWidget && this.config?.editOptions) {

            if (this.config.editOptions.onChangedEventName) {
                this.__evEditorWidget.on(this.config.editOptions.onChangedEventName, lang.hitch(this, this._onChanged_Editor));
            }
            if (this.config.editOptions.onDeletedEventName) this.__evEditorWidget.on(this.config.editOptions.onDeletedEventName, lang.hitch(this, this._onDeleted_Editor));
            if (this.config.editOptions.onSavedEventName) {
                this.__evEditorWidget.on(this.config.editOptions.onSavedEventName, lang.hitch(this, this._onSaved_Editor));
            }
        }

        this.isEditing = true;        
    }

    private _onSavedEditorTimeout;
    private _onSaved_Editor() {
        if (this._onSavedEditorTimeout) clearTimeout(this._onSavedEditorTimeout);

        this._onSavedEditorTimeout = setTimeout(lang.hitch(this, this.onEntityChange), 100);
    }
    private _onDeletedEditorTimeout;
    private _onDeleted_Editor() {
        if (this._onDeletedEditorTimeout) clearTimeout(this._onDeletedEditorTimeout);

        this._onDeletedEditorTimeout = setTimeout(lang.hitch(this, this._afterDelete), 100);
        //this._onDelete();
    }

    private _onChanged_Editor() {
        // ist jetzt die Frage: eigentlich interessiert uns ein change des Editors nicht wirklich, weils erst beim Speichern wirklich relevant wird...
        // das save führt nach außen zum "change", weil sich das Entity jetzt in der DB geändert hat.
        // aber das bloße change im Editor ständig nach außen geben ist zu viel. glaub ich.
    }


    protected onRequestEditor(entityID: string, entity): MdsLax<InstanceType<typeof _WidgetBase>> {
        // wird in Kindklasse überdefiniert

        alert("no editor defined for " + this.id);

        return null;
    }
    protected onDelete() {
        // wird in Kindklasse überdefiniert
    }
    protected afterClone() {
        // wird in Kindklasse überdefiniert
        this.emit("cloned");

    }
    protected afterDelete() {
        // wird in Kindklasse überdefiniert
    }
    protected onSave() {
        // wird in Kindklasse überdefiniert
    }
    protected onRollback() {
        // wird in Kindklasse überdefiniert
    }
    protected onClose() {
        // wird in Kindklasse überdefiniert
    }
    protected onEntityChange() {

        this.loadViewData();

        this.emit("change");
        topic.publish("/Entity/Changed", { changedEntityID: this.entityID });
    }
    protected onViewContentSet() {
        // wird in Kindklasse überdefiniert
    }
    protected onDataLoaded() {
        // wird in Kindklasse überdefiniert
    }
    protected onClone(entityID: string, entity: X) {

    }
    protected onReload() {

    }

    protected deletingEnabled: boolean = false;
    protected deletingAllowed: boolean = false;
    protected editingAllowed: boolean = false;
    protected editingEnabled: boolean = false;
    protected cloningAllowed: boolean = false;
    protected cloningEnabled: boolean = false;


    protected config: EntityViewTypes.EnityFrameOptions<X> = {
        entityClassname: null,
        entityClassPrintname: "config?entityClassPrintname",
        requestDataFunctionname: null
    };

    /**
     * Einen beliebigen Kontextnamen vergeben, der beim Request mitgegeben wird.
     * Der Kontext kann im Backend dazu verwendet werden, die Inhalte zu differenzieren, indem der Zweck der Ansicht als Stichwort mitgegeben wird.
     * @param name Beliebiger Name, Standard ist 'default'
     */
    setContextName(name: string = "default") {
        this.contextName = name;
    }

    //setContextValue(name: string, value: string | number | boolean) {

    //}
    private _setup(entityId?: string, label?: string, groupHeading?: string) {

        if (!this.config /*|| !this.config.entityClassname*/ /* entityview kann auch mal ohne Entity befüllt sein, auch wenns unlogisch klingt */) {
            alert(this.id + ": invalid or missing configuration for entity view!")
            return;
        }

        if (this.config?.entityClassname) {
            this.UiModder.domClass.toggle(this.domNode, this.config.entityClassname);
        }

        if (!entityId && !this.entityID && this.entity && this.config?.idProperty) {
            entityId = this.entity[this.config.idProperty];

        }

        if (entityId) {
            if (this.entityID && this.entityID != entityId) {
                this.viewData = null;
                this.UiModder.domConstruct.empty(this.contentContainer);
            }

            this.entityID = entityId;

            if (this.entity) {
                let existingEntityId = this.entity[this.config.idProperty];
                if (existingEntityId != this.entityID && !!this.entityID) {
                    this.entity = null;
                }
            }
        }


        if (this.domNode.getAttribute("entityId") != this.entityID) {
            this.UiModder.domConstruct.empty(this.contentContainer);
        }
        this.domNode.setAttribute("data-entityId", this.entityID);
        this.domNode.setAttribute("entityId", this.entityID);
        this.internalName = this.entityID;

        if (groupHeading != undefined) this.groupLabel = groupHeading;

        if (label) this.title = label;
        label = this.title;

        if (!label) {
            if (this.entity) {
                if (this.config.labelProperty) {
                    label = this.entity[this.config.labelProperty];
                }

                if (!label && this.config.entityClassPrintname) {
                    label = this.config.entityClassPrintname;
                }
            }
        }


        let colorStr: string = null;
        if (this.config.colorProperty && this.entity) {
            let value = this.entity[this.config.colorProperty];

            if (!!value) {
                if (typeof (value) == "string") {
                    colorStr = value;
                } else if (typeof (value) == "object" && value.BackColor) {
                    colorStr = (value as more.EntityAPIColor).BackColor.Hex;
                }
            }

            this.tabColor = colorStr;
        }

        this._setupFrameContainers();

    }

    private _onDlgClosed() {

    }
    // Tab-Mixin:
    _onClosing() {
        super._onClosing.apply(this, arguments as any);
        this.openEditorTab = null;
        this.close();
    }

    getTitle(): string {
        return this.title;
    }
    getHeading(): string {
        return this.getTitle();
    }

    private _onDlgResult(result: number) {

        if (result <= 0) {
            this.close();
        }

        if (result >= 1) // yes, ok, save, etc...
        {

        }
    }

    onShow() {

    }
    /**
     * Versucht, statt der View-Ansicht gleich den Editor zu öffnen und prüft dazu die übergebenen Parameter.
     * Benötigte Rollen und Features sowie der Editoraufruf müssen im Entityview konfiguriert bzw. programmiert sein.
     * @param entityId
     * @param entityClassname
     * @param heading
     * @returns
     */
    tryOpenEditor(entityId?: string,
        entityClassname?: string,
        heading?: string) {
        if (entityId && entityClassname) {
            if (entityId != this.entityID) {
                this.entityID = entityId;
                this.config.entityClassname = entityClassname;
                this._setup(entityId, heading);
                this.checkPrivileges(lang.hitch(this, this.tryOpenEditor));
                return;
            }
        }

        if (this.openEditor() != true) {
            this.showAsDlg(entityId, heading);
        }
    }
    /**
     * Erzwingt das Öffnen des Editors unabhängig von Rollen, Features und Rechten.
     * Der Editor muss bereits konfiguriert/programmiert worden sein, damit der Vorgang erfolgreich sein kann.
     * @param entityId
     * @param entityClassname
     * @param heading
     * @param targetTabcontainer
     * @returns
     */
    forceOpenEditor(entityId?: string,
        entityClassname?: string,
        heading?: string,
        targetTabcontainer?: string) {

        if (targetTabcontainer) this.tabContainerName = targetTabcontainer;

        if (entityId && entityClassname) {

            if (entityId) this.entityID = entityId;
            if (entityClassname) this.config.entityClassname = entityClassname;

            this._setup(entityId, heading);
        }

        this.editingAllowed = true;
        return this.openEditor();
    }

    openEditor(): boolean {

        if (!this.entityID) return false;

        if (this.editingAllowed) {
            if (this.dlg) this.dlg.close(-1, true);
            this._onRequestEditor(this.entityID, this.entity);
            this.isEditing = true;
            return true;
        }

        return false;
    }

    getEntityData(): X {
        return this.entity;
    }

    getEntityId(): string {
        return this.entityID;
    }

    setAdditionalRequestParameters(data: Object, bReplaceExistingParameters?: boolean) {
        if (data) {
            if (bReplaceExistingParameters == true) {
                this.config.additionalRequestParams = lang.clone(data);
            } else {
                for (let key in data) {
                    this.addAdditionalRequestParam(key, data[key]);
                }
            }
        } else {
            this.config.additionalRequestParams = null;
        }
    }

    addAdditionalRequestParam(name: string, value: any) {

        if (!name) return;

        if (!this.config.additionalRequestParams) {
            this.config.additionalRequestParams = {};
        }

        if (typeof (value) == "object") {
            this.config.additionalRequestParams[name] = lang.clone(value);
        } else {
            this.config.additionalRequestParams[name] = value;
        }
    }
    private getRequestData(): EntityViewTypes.RequestBaseData {
        let data: EntityViewTypes.RequestBaseData = {
            entityID: this.entityID,
            entityClass: this.config.entityClassname,
            contextURL: location.href,
            contextName: this.contextName
        };

        if (this.config.additionalRequestParams) {
            for (let key in this.config.additionalRequestParams) {
                data[key] = this.config.additionalRequestParams[key];
            }
        }



        return data;
    }
    reload() {
        if (this._destroyed) return;
        if (this._loadRequest) return;

        this.loadViewData();
    }
    private _loadRequest: dojo.request.Promise<any> = null;
    private loadViewData(entityId?: string) {
        if (this._destroyed) return;
        if (entityId) this.entityID = entityId;

        if (this._loadRequest) {
            this._loadRequest.cancel();
        }

        this.isLoaded = false;

        entityId = this.entityID;

        if (!entityId) return;

        if (!this.config.requestDataFunctionname) return;

        let data = this.getRequestData();

        this.StandbyStart();

        this._loadRequest = this.RequestManager.callfunction(
            this.config.requestDataFunctionname,
            data,
            lang.hitch(this, this._onLoadData),
            lang.hitch(this, this._onLoadDataError)
        );


    }

    setNonInteractive(bValue?: boolean) {
        if (bValue !== true && bValue !== false) bValue = true;

        if (this.__isNonInteractiveEntityView != bValue) {
            this.__isNonInteractiveEntityView = bValue;

            this.UiModder.domClass.toggle(this.contentContainer, "nonInteractive", this.__isNonInteractiveEntityView);

            if (this.viewData) this._applyData();
        }
    }

    private _onLoadData(data: EntityViewTypes.EntityViewResponse<X>) {
        this._loadRequest = null;
        this.StandbyStop();

        this.viewData = data;
        this.entity = data.entity;

        this.isLoaded = true;

        this._applyData();
        this.checkPrivileges();


        try {
            this.onDataLoaded();
        } catch (ex) {

        }

        this.emit("loaded", this.entity);
        this._afterLoaded();
    }
    protected _afterLoaded() {
        //To implement in child class
    }

    private _onLoadDataError(error: more.requestErrorMessage) {
        this._loadRequest = null;
        this.StandbyStop();

        alert(error.Message);
    }

    private createEditContainer(): HTMLElement {
        let container = this.UiModder.domConstruct.create("div", {
            className: "padding round border brightOpaqueBG entityViewEditorContainer"
        });

        let inputContainer = this.UiModder.domConstruct.create("div", {
            className: "w3-block",
            id: "inputContainer"
        }, container);

         let buttonContainer = this.UiModder.domConstruct.create("div", {
            className: "w3-block flex_row_center justify flex_gapSmall",
            id: "buttonContainer"
        }, container);

        let buttonOK = this.UiModder.domConstruct.create("button", {
            className: "mds-button-base hoverBright accentBG w3-disabled",
            id: "buttonOK",
            innerHTML: this.createFontawesomeIcon("fas fa-check").outerHTML
        }, buttonContainer);

        let buttonCancel = this.UiModder.domConstruct.create("button", {
            className: "mds-button-base hoverBright secondaryBG w3-disabled",
            id: "buttonCancel",
            innerHTML: this.createFontawesomeIcon("fas fa-times").outerHTML
        }, buttonContainer);

        return container;
    }
    /*
    private _localStorageSettings: EntityViewUserSettings;
    private _storageKey: string;
    private _loadUserSettingsFromLocalStorage() {
        let storage = PermissionHelper.getAvailableStorageMediumForCaching();
        if (!storage) return;

        let keyName = "user:" + this.getCurrentUserId(null, true) + "_entity:" + this.entityID + "_widget:" + this["declaredClass"] + "_context:" + (this.contextName ? this.contextName : "default");
        if (this._storageKey) keyName = this._storageKey;
        if (!this._storageKey) this._storageKey = keyName;

        let strData = storage.getItem("ego_EntityviewUsersettings");
        if (strData) {
            try {
                let data: Record<string, EntityViewUserSettings> = JSON.parse(strData);

                if (data) {
                    this._localStorageSettings = data[keyName];
                }

            } catch (ex) {

            }
        }

        if (!this._localStorageSettings) {
            this._localStorageSettings = {
                contextname: this.contextName ? this.contextName : "default",
                entityID: this.entityID,
                expanderStates: {},
                widgetClass: this["declaredClass"]
            };

            this._saveUserSettingsToLocalStorage();
        }
    }

    private _saveUserSettingsToLocalStorage() {
        if (this._localStorageSettings && this._storageKey) {
            let storage = PermissionHelper.getAvailableStorageMediumForCaching();
            if (!storage) return;

            let keyName = this._storageKey;

            let strData = storage.getItem("ego_EntityviewUsersettings");
            let data: Record<string, EntityViewUserSettings>;


            if (strData) {
                try {
                    data = JSON.parse(strData);

                } catch (ex) {

                }
            }

            try {
                if (!data) data = {};

                data[keyName] = this._localStorageSettings;

                storage.setItem("ego_EntityviewUsersettings", JSON.stringify(data));
            } catch (ex) {

            }
        }
    }
    */
    protected setViewData(viewData: EntityViewTypes.EntityViewResponse<X> | string) {

        if (typeof (viewData) == "string") {
            let pseudoData: EntityViewTypes.EntityViewResponse<any> = {
                content: viewData,
                entity: null,
                label: null,
                entityId: null,
                entityClassname: null
            };
            viewData = pseudoData;
        }

        this.viewData = viewData;

        this._applyData();
    }

    private _applyData() {

        let data = this.viewData;
        let entity = this.entity;

        this._isEmptyContent = true;

        //this._loadUserSettingsFromLocalStorage();

        if (data) {
            this.UiModder.domConstruct.empty(this.contentContainer);

            if (entity) {
                this.domNode.setAttribute("data-entityClassname", (entity as any).Classname)
                this.domNode.setAttribute("entityClassname", (entity as any).Classname)
            }

            // testen ob HTML:
            let testContainer = this.UiModder.domConstruct.create("div");
            this.UiModder.domAttr.set(testContainer, "innerHTML", data.content);

            let isHtmlContent = testContainer.childElementCount > 0;

            this.UiModder.domConstruct.destroy(testContainer);

            if (isHtmlContent === true) {
                this.UiModder.domAttr.set(this.contentContainer, "innerHTML", data.content);


                this._handleLabels();
                this._handleExpanderContent();
                this._handlePageStacks();
                this._handleActionButtons();
                this._handleCheckboxes();
                this._handleTables();

                this._isEmptyContent = this.contentContainer.childElementCount == 0;

            } else {
                let pre = this.UiModder.domConstruct.create("pre", {
                    innerHTML: data.content,
                    className: "entityData"
                }, this.contentContainer, "only");

                this._isEmptyContent = !data.content;
            }
        }

        let newHeading = "";
        if (entity) {
            if (entity[this.config?.labelProperty]) {
                newHeading = entity[this.config.labelProperty];
            }
        } else if (data.label) newHeading = data.label;

        if (newHeading) {
            this.title = newHeading;

            if (this.dlg) {
                this.dlg._setHeaderAttr(newHeading);
            }

            if (this.isStandalone) {
                this._createFrameHeading(newHeading);
            }

        }

        this.hideIfEmpty(this._hideIfEmpty);

        this.onViewContentSet();
    }

    /**
     * Den Inhalt der Entityview ausblenden, falls leer.
     * Rückgabe: true, wenn sich die View ausblendet.
     * Callback: Wird aufgerufen, sobald sich der Zustand ändert (Parameter: boolean)
     */
    hideIfEmpty(bHide: boolean = true, callback?: Function): boolean {
        this._hideIfEmpty = bHide;

        let bOverrideResult: boolean = false;
        if (typeof (callback) != "undefined") {
            this._hidingCallback = callback;
            bOverrideResult = !!callback; // wenns ein neues Callback gibt, dann unbedingt aufrufen.
        }

        callback = this._hidingCallback;

        let bHideTarget = this._isEmptyContent && this._hideIfEmpty;

        this.hideNode(this.domNode, bHideTarget);

        if (this._isHidden != bHideTarget || bOverrideResult) {
            this._isHidden = bHideTarget;
            if (callback) callback(bHideTarget);
        }

        return bHideTarget;
    }

    private _handleTables() {

        //TODO - optimize

        let tableElements = this.contentContainer.getElementsByTagName("table");
        let tableTargetContents = ["th", "tr", "td"];

        let afterProcessQueueBG:Array<{elem:HTMLElement, val:any}> = [];
        let afterProcessQueueColor: Array<{ elem: HTMLElement, val: any }> = [];


        for (let t = 0; t < tableElements.length; t++) {
            let table: HTMLTableElement = tableElements[t];


            if (table.classList.length == 0) {
                this.UiModder.domClass.add(table, "responsiveTable");
            }

            let headings: Array<string> = [];
            let headingColspans: Array<number> = [];

            for (let target of tableTargetContents) {
                let tableContents = table.getElementsByTagName(target);

                for (let i = 0; i < tableContents.length; i++) {
                    let element = tableContents[i] as HTMLElement;

                    if (target == "th") {
                        // aus der TH die erste Textnode rauslesen - wird als Überschrift verwendet
                        // Achtung: das ist nicht exakt. Müsste eigentlich genau alle Tablerows parsen und mit colspan und td/th-Elementen die maximale Spaltenanzahl einer Reihe ermitteln.
                        // falls mehrzeilige Tabellenüberschriften oder -layouts benutzt werden, sind wir hier eh auf verlorenem Posten.
                        let headerCell = <HTMLTableCellElement>element;
                        let array = headerCell.childNodes;
                        let headingContent = "";
                        for (let x = 0; x < array.length; x++) {
                            let child = array[x] as HTMLElement

                            if (child.nodeName == "#text") {
                                headingContent = child.textContent;
                                if (this.canTranslate(headingContent)) {
                                    headingContent = this.translate(headingContent);
                                    child.textContent = headingContent;
                                }
                                break;
                            }
                        }

                        let colspan = 1;
                        if (headerCell.colSpan) colspan = headerCell.colSpan;
                        for (let y = 0; y < colspan; y++) {
                            headings.push(headingContent);
                            headingColspans.push(colspan);
                        }



                    } else if (target == "tr") {
                        // im zweiten Durchlauf lesen wir dann die rows - dann verteilen wir pro row die headings.
                        let array = element.getElementsByTagName("td");
                        for (let x = 0; x < array.length; x++) {
                            let tableCell = array[x] as HTMLTableCellElement

                            let cellColspan = tableCell.colSpan ? tableCell.colSpan : 1;

                            // falls die colspans nicht zusammenpassen, ist es womöglich eine zweite, unbekannte Row (tr)
                            if (headings.length > x && cellColspan == headingColspans[x]) {
                                tableCell.setAttribute("data-label", headings[x]);
                            }

                            if (tableCell.colSpan) x = x + tableCell.colSpan - 1;
                        }
                    }


                    if (target == "th" || target == "td") {
                        if (element.classList.length == 0) {
                            element.classList.add("default");

                            // Klassen sind keine gesetzt. aber womöglich Färbung?
                            let css = window.getComputedStyle(element);
                            let bgcolor = null;
                            let txtcolor = null;

                            // die berechneten css-Farben nur übernehmen, wenn wirklich auf style explizit ein Elementstyle gesetzt ist:
                            if (element.style.color) {
                                txtcolor = css.color;
                            }
                            if (element.style.backgroundColor) {
                                bgcolor = css.backgroundColor;
                            }
                            
                           

                            if (bgcolor) {
                                // wir setzten das zeug spaeter damit window.getComputedStyle schneller berechnet im browser
                                afterProcessQueueBG.push({
                                    elem:element,
                                    val:bgcolor,
                                });
                            }

                            if (txtcolor) {
                                // wir setzten das zeug spaeter damit window.getComputedStyle schneller berechnet im browser
                                afterProcessQueueColor.push({
                                    elem:element,
                                    val:txtcolor
                                });
                            }

                            // falls es weitere Inhalt gibt, dann diese in einen Container stecken, damit die Styles halbwegs in den Griff zu bekommen sind
                            let array = element.childNodes;
                            let children = []; // neues Array machen, damit das Domconstruct nicht byref die Liste beeinflusst!
                            for (let x = 0; x < array.length; x++) {
                                children.push(array[x]);
                            }


                            if (children.length > 1) {
                                //let containerFirst = this.UiModder.domConstruct.create("div", { className: "wrapper left" }, element, "first");
                                //let containerMid = this.UiModder.domConstruct.create("div", { className: "wrapper mid" }, element, "last");
                                //let containerLast = this.UiModder.domConstruct.create("div", { className: "wrapper right" }, element, "last");
                                //let target = containerFirst;

                                for (let x = 0; x < children.length; x++) {
                                    let child = children[x] as HTMLElement

                                    let wrapper = this.UiModder.domConstruct.create("div", { className: "wrapper" }, element, "last");
                                    this.UiModder.domConstruct.place(child, wrapper);

                                    //if (child.nodeName != "#text" && child != target) {
                                    //    this.UiModder.domConstruct.place(child, target);
                                    //} else if (child.nodeName == "#text") {
                                    //    this.UiModder.domConstruct.place(child, containerMid);
                                    //    target = containerLast;
                                    //}
                                }
                            }
                        }
                    }
                }
            }

            for (let queueElem of afterProcessQueueBG){
                let targetElem: HTMLElement = queueElem.elem;
                this.UiModder.domStyle.set(targetElem, "backgroundColor", "");
                let val = queueElem.val;
                if (val === "transparent") val = "none"; // kooperiert besser mit Darktheme, weil Dunklerrechnen im CSS weiterhin wirklich "keine" Farbe ergibt
                targetElem.style.setProperty("--bgColor", val);
            }
            for (let queueElem of afterProcessQueueColor){
                let targetElem: HTMLElement = queueElem.elem;
                this.UiModder.domStyle.set(targetElem, "color", "");
                targetElem.style.setProperty("--txtColor", queueElem.val);
            }
        }
    }
    private _handleLabels() {

        let elements = this.contentContainer.getElementsByTagName("label");
        for (let i = 0; i < elements.length; i++) {
            let label = elements[i] as HTMLElement;

            this.UiModder.domClass.add(label, "entityViewLabel");
        }
    }

    private _knownContextButtons: Array<string>;

    private _handleActionButtons() {

        // vorher hinzgefügte Buttons wieder entfernen!
        if (this._knownContextButtons?.length) {
            for (let name of this._knownContextButtons) {
                this.requestContextButtonRemove(name);
            }

            this._knownContextButtons = [];
        }
        let elements = this.contentContainer.getElementsByClassName("entityViewAction");
        for (let i = 0; i < elements.length; i++) {
            let buttonElement = elements[i] as HTMLButtonElement;

            if (buttonElement.nodeName.toLocaleLowerCase().indexOf("button") != -1 ) this.UiModder.domClass.add(buttonElement, "buttonBase");


            // Label übersetzen, aber Vorsicht: im Button kann auch ein icon drinstecken!
            try {
                for (let i = 0; i < buttonElement.childNodes.length; i++) {
                    let child = buttonElement.childNodes[i];
                    if (child.nodeType == 3) { // Text
                        let content = child.textContent;
                        if (this.canTranslate(content)) child.textContent = this.translate(content);
                    }
                }

                if (buttonElement.title) {
                    if (this.canTranslate(buttonElement.title)) buttonElement.title = this.translate(buttonElement.title);
                }
            } catch (ex) {

            }


            let actionType: EntityViewTypes.actionType = buttonElement.getAttribute("data-actiontype") as EntityViewTypes.actionType;
            let entityClass = buttonElement.getAttribute("data-entityclass");
            let entityId = buttonElement.getAttribute("data-entityid");
            let callfunction = buttonElement.getAttribute("data-callfunction");
            //let actionName = buttonElement.getAttribute("data-actionname");
            let attribute = buttonElement.getAttribute("data-attributepath");
            let originalvalue = buttonElement.getAttribute("data-value");

            let parametersStr = buttonElement.getAttribute("data-parameters");
            
            let parameters = null;
            if (parametersStr) {
                try {
                    parameters = JSON.parse(parametersStr);
                } catch (ex) {
                    parameters = parametersStr;
                }
            }

            let contextName = buttonElement.getAttribute("data-context-name");
            

            let defaultParams: EntityViewTypes.ActionParameters = {
                node: buttonElement,
                entityId: entityId,
                entityClass: entityClass,
                callfunctionName: callfunction,
                actionType: actionType,
                //actionName: actionName,
                attributepath: attribute,
                originalvalue: originalvalue,
            };

            if (parameters) defaultParams.additionalConfig = parameters;
            
            if (typeof (contextName) == "string") defaultParams.contextName = contextName;

            let clickFct = null;

            switch (actionType) {
                case "ENTITYVIEW":
                    clickFct = lang.hitch(this, this._onAction_RequestEntityView, defaultParams);
                    break;

                case "ATTRIBUTEEDIT":
                    clickFct = lang.hitch(this, this._onAction_AttributeEdit, defaultParams);
                    break;

                case "ACTION":
                case "USERINPUT":
                case "DOWNLOAD":
                    clickFct = lang.hitch(this, this._onAction, defaultParams);
                    break;

                default:

                    break;
            }

            this.UiModder.domClass.toggle(buttonElement, "disabled", this.__isNonInteractiveEntityView && actionType != "ENTITYVIEW");
            this.UiModder.domClass.toggle(buttonElement, "hoverBright", !this.__isNonInteractiveEntityView || actionType == "ENTITYVIEW");


            if (this.__isNonInteractiveEntityView && actionType != "ENTITYVIEW") clickFct = null; // UNBEDINGT BEI NONINTERACTIVE DEAKTIVIEREN!

            if (!this.__isNonInteractiveEntityView) {
                if (buttonElement.tagName.toLowerCase() == "primaryframebutton" || buttonElement.tagName.toLowerCase() == "framebutton") {
                    let icons = buttonElement.getElementsByTagName("i");
                    let isPrimary = buttonElement.tagName.toLowerCase() == "primaryframebutton";



                    this.requestContextButton({
                        callback: clickFct,
                        label: buttonElement.innerText.trim(),
                        iconClass: icons?.length ? icons[0].className : null,
                        permanent: false,
                        coloration: null,
                        enabled: clickFct != null,
                        name: callfunction,
                        placement: isPrimary ? "actionbar" : "actionmenu"
                    });


                    this._knownContextButtons.push(callfunction); // merken, beim nächsten Update muss der Kontextbutton erst mal raus!

                    this.hideNode(buttonElement);
                }

                else {

                    if (clickFct) {
                        on(buttonElement, "click", clickFct);
                    } else {
                        this.disableNode(buttonElement);

                    }

                    if (buttonElement.classList.contains("customBG")) {
                        try {
                            let css = window.getComputedStyle(buttonElement);
                            let isDark = this.isDarkColor(css.backgroundColor);
                            this.UiModder.domClass.toggle(buttonElement, "darkBG", isDark);
                        } catch (ex) {

                        }
                    }
                }
            }

        }
    }

    private _onAction_AttributeEdit(params: EntityViewTypes.ActionParameters, evt) {

            //evt.stopPropagation();
        let editor = this.createEditContainer();
        let floatingContainer = new FloatingContainer();
        floatingContainer.open(evt, editor, true, null, params.node);

    }

    private _onAction(params: EntityViewTypes.ActionParameters) {
        if (this.__isNonInteractiveEntityView) return;

        let data: EntityViewTypes.ActionRequestData = {
            entityClass: params.entityClass,
            entityID: params.entityId,
            contextURL: location.href,
            contextName: params.contextName ? params.contextName : this.contextName,
            actiontype: params.actionType,
            functionname: params.callfunctionName,
            parameters: {
            //    actionName: params.actionName
            },
            
        };

        if (params.additionalConfig) {

            data.parameters = {  ...params.additionalConfig };
        }

        let responsecallback = null;
        let errorcallback: any = lang.hitch(this, this._onActionError, params);

        switch (params.actionType) {
            case "ENTITYVIEW":
                return; // hierher kommen wir nicht!
                break;

            case "CHECKBOX":
                // die Parameter enthalten als node den tatsächlichen Actionbutton. diesen auslösen!
                if (params.node.parentElement) {
                    params.node.parentElement.click();
                }
                return;
                break;

            case "ACTION":
                //this.hourGlassStart(params.node);
                this.StandbyStart();

                this.RequestManager.callfunction("Webtool_API_EntityView__ExecuteAction",
                    data,
                    lang.hitch(this, this._onActionResponse, params),
                    errorcallback,
                    false);
                break;

            case "DOWNLOAD":
                this.hourGlassStart(params.node);
               
                if (params.callfunctionName) {

                    this.RequestManager.callfunction("Webtool_API_EntityView__ExecuteAction",
                        data,
                        lang.hitch(this, this._onActionResponse, params),
                        errorcallback,
                        false);
                } else {

                    let downloadKey = params.node.getAttribute("data-download-key");

                    let requestData: FileFinder.DescriptorRequestData = {
                        key: downloadKey
                    }
                    if (this.hasFeature("filePreview", "useInEntityView") == false) {
                        if (this.hasFeature("System/UseControllerFileResultsForDownloads")) {
                            this.hourGlassEnd(params.node);
                            location.href = window.appRoot + this.stringFormat("FileTransfer/Download?downloadKey={0}", encodeURIComponent(downloadKey));
                        } else {
                            this.RequestManager.callfunction("Webtool_API_FileTransfer__DownloadDescriptorByKey",
                                requestData,
                                lang.hitch(this, this._onDownloadResponse, params),
                                errorcallback,
                                false);
                        }
                    }else{
                        //wenn das Feature gesetzt wurde, dann benutzen wir die file preview, die auch den download mit dem descriptor key verwendet                   
                        this.filePreviewWidget = new (mdsRequire('WidgetCollection/filePreview/filePreview'))();
                        this.filePreviewWidget.show(
                            requestData,
                            true,
                            true,
                            lang.hitch(this, this.hourGlassEnd, params.node),
                            errorcallback
                        );
                    }
                }
                return;
                break;

            case "USERINPUT":
                this.hourGlassStart(params.node);

                data.parameters = {
                    ...data.parameters,
                    "attributepath": params.attributepath
                }

                this.RequestManager.callfunction("Webtool_API_EntityView__ExecuteAction",
                    data,
                    lang.hitch(this, this._onActionResponse, params),
                    errorcallback,
                    false);
                break;

            default:

                break;
        }
    }
    private _onActionResponse(sourceparams: EntityViewTypes.ActionParameters, response: EntityViewTypes.ActionResponse<any>) {
        if (!response.actionType) response.actionType = sourceparams.actionType;

        if (response.actionType !== "ACTION") this.hourGlassEnd(sourceparams.node);

        switch (response.actionType) {
            case "ENTITYVIEW":
                return; // hierher kommen wir nicht!
                break;

            case "DOWNLOAD":
                if (response.success) {
                    this._onDownloadResponse(sourceparams, response.result);
                }
                break;

            case "ACTION":
                this.StandbyStop();
                if (response.success) {
                    this.onEntityChange();
                } else {
                    this._applyData();
                }
                break;

            case "USERINPUT":
                if (response.success) {
                    this._onUserInputConfig(sourceparams, response);
                }
                break;

        }



        if (response.message) {
            this.showToast({
                title: response.message,
                iconClass: response.success === true ? toasterIcons.confirmCheck : response.success === false ? toasterIcons.warning : null,
                ID: sourceparams.entityId + sourceparams.entityClass + sourceparams.callfunctionName,
                message: response.errorMessage ? response.errorMessage : response.messageLong,
                timeout: response.errorMessage ? "permanent" : response.messageLong ? 20000 : null,
            });
        } else if (response.messageLong) {
            let dlg = new GenericDialog();
            dlg.setSize("smaller");
            dlg.show(response.messageLong, sourceparams.node.innerText, response.message, null, "ok", null);
        }
    }


    private _onDownloadResponse(sourceparams: EntityViewTypes.ActionParameters, response: FileFinder.FileDescriptorWithBase64) {
        this.hourGlassEnd(sourceparams.node);
        this.StandbyStop();

        let result = FileHelpers.provideFile(response, null, "filePreview/useInEntityViewOverwriteActions");
    }

    private _onEditConfig(sourceparams: EntityViewTypes.ActionParameters, config: EntityViewTypes.UserInputConfig) {
        let dlg = new GenericDialog();
        dlg._setCloseBtnAttr(false);
        dlg._setTopCloseBtnAttr(false);

        dlg._setCancelBtnAttr(true);

        let input: MdsLax<InstanceType<typeof _StatefulBase>> = null;

        switch (config.type) {
            case "multilineinput":
                dlg._setOkBtnAttr(true);
                let multilineEdit = new Edit();
                multilineEdit.setIsMultiline(true);
                multilineEdit.setValue(sourceparams.originalvalue);

                dlg.addNodeToContent(multilineEdit.domNode);

                input = multilineEdit;
                break;

        }
    }

    private _onUserInputConfig(sourceparams: EntityViewTypes.ActionParameters, response: EntityViewTypes.ActionResponse<EntityViewTypes.UserInputConfig>) {
        let config = response.result;

        if (!config) {
            alert("no config received! check if callfunction uses setActionResult");
            return;
        }

        switch (config.type) {
            case "multilineinput":
            case "textinput":
            case "dateinput":
            case "timeinput":
            case "datetimeinput":
                this._onEditConfig(sourceparams, config);
                break;
        }

        if (config.type != "selectentitydialog") {
            let dlg = new GenericDialog();

            if (config.type == "filterpanelwithoverflow") {
                dlg.enableContentOverflow(true);
            }
            dlg._setHeaderAttr(config.title);

            dlg._setCancelBtnAttr(true);
            dlg._setTopCloseBtnAttr(false);
            dlg._setCloseBtnAttr(false);
            dlg._setOkBtnAttr(false);
            dlg.setSize("smaller");
            dlg.closeOnEnter = false;
            dlg.closeOnEscape = true;

            dlg.keepOpen = true;

            let filterPanel: MdsLax<InstanceType<typeof FilterPanelWidget>> = null;


            if (config.message) dlg._setContentAttr(config.message, "p");

            switch (config.type) {
                case "filterpanel":
                case "filterpanelwithoverflow":
                    dlg._setOkBtnAttr(true, false);
                    if (typeof (config.inputEnabledOnStart) != "boolean") config.inputEnabledOnStart = false;
                    break;

                case "yes":
                case "yesno":
                case "yesnocancel":
                    dlg._setYesBtnAttr(true);
                    dlg._setNoBtnAttr(true);
                    if (typeof (config.inputEnabledOnStart) != "boolean") config.inputEnabledOnStart = true;
                    if (config.type == "yesno" || config.type == "yes") {
                        dlg._setCancelBtnAttr(false);
                        dlg.setDistinctiveCallbacksMode(true, null, "silentclose");
                    }
                    break;

                case "ok":
                    dlg._setOkBtnAttr(true);
                    if (typeof (config.inputEnabledOnStart) != "boolean") config.inputEnabledOnStart = true;
                    break;

                case "custombuttons":
                    if (typeof (config.inputEnabledOnStart) != "boolean") config.inputEnabledOnStart = false;
                    for (let button of config.buttons) {
                        dlg.addButton((Math.random() * 10000).toFixed(0),
                            button.label,
                            lang.hitch(this, this._onUserInputDlgResponse_Custom, sourceparams, dlg, filterPanel, button.value),
                            button.description,
                            "primaryBG",
                            button.icon,
                            false);
                    }
                    break;

            }

            // filterpanel immer ergänzen falls konfiguriert
            let configWithFilterPanel = config as EntityViewTypes.UserInputConfig & FilterPanelTypes.PanelConfig;
            if (configWithFilterPanel.sections && configWithFilterPanel.sections.length) {

                filterPanel = new FilterPanelWidget();
                dlg.addNodeToContent(filterPanel.domNode);

                filterPanel.setSectionData(configWithFilterPanel.sections);
                filterPanel.hideSectionIfSingle(true);
                filterPanel.setAlternativeMandatoryMode(true);
                filterPanel.on("change", lang.hitch(this, function (dlg: MdsLax<InstanceType<typeof GenericDialog>>, fp: MdsLax<InstanceType<typeof FilterPanelWidget>>) {
                    dlg.disableAllButtons(!fp.valid);
                    dlg.enableButton("cancel");
                }, dlg, filterPanel));
            }

            dlg._setCallbackAttr(lang.hitch(this, this._onUserInputDlgResponse, sourceparams, dlg, filterPanel));

            dlg.show();

            if (config.inputEnabledOnStart !== true) {

                setTimeout(lang.hitch(dlg, "disableAllButtons"), 100);
            }
            setTimeout(lang.hitch(dlg, "enableButton", "cancel"), 110);

        } else {
            let configWithSED = config as EntityViewTypes.UserInputConfig & SelectEntityDialogTypes.DlgConfiguration<any>;
            let SelectEntityDialogClass: any = mdsRequire("moreCore/UI/SelectEntityDialog/SelectEntityDialog");
            let dlg = (new SelectEntityDialogClass()) as MdsLax<InstanceType<typeof SelectEntityDialog<any>>>; //NOTE - dynamic require wegen loop import

            dlg.setConfiguration(configWithSED, lang.hitch(this, this._onUserInputSEDResponse, sourceparams, dlg), null);

            let data: EntityViewTypes.ActionRequestData = {
                actiontype: "SELECTENTITYDIALOGSEARCH",
                functionname: sourceparams.callfunctionName,
                entityClass: sourceparams.entityClass,
                entityID: sourceparams.entityId,
                contextURL: location.href,
                contextName: sourceparams.contextName ? sourceparams.contextName : this.contextName,
                parameters: {
                //    actionName: sourceparams.actionName
                }
            };

            for (let key in data) {
                dlg.addRequestParameter(key, data[key]);
            }
            //dlg.addGlobalRequestProperty("parameters", );

            dlg.show();

        }
    }

    private _onUserInputSEDResponse(sourceparams: EntityViewTypes.ActionParameters, dlg: MdsLax<InstanceType<typeof SelectEntityDialog<any>>>, values: Array<string>, items: Array<SelectEntityDialogTypes.Item<any>>) {

        if (!values?.length) {
            if (dlg.allowEmptyValue == true) {
                values = [null];
            } else return;
        }


        this.StandbyStart();

        let data: EntityViewTypes.ActionRequestData = {
            actiontype: "ACTION",
            parameters: {
                userselect: values && values.length > 1 ? values : values[0],
                inputDialogType: "selectentitydialog",
            //    actionName: sourceparams.actionName,
            },
            entityClass: sourceparams.entityClass,
            entityID: sourceparams.entityId,
            contextURL: location.href,
            contextName: this.contextName,
            functionname: sourceparams.callfunctionName
        };

        this.RequestManager.callfunction("Webtool_API_EntityView__ExecuteAction",
            data,
            lang.hitch(this, this._onUserInputResponse, sourceparams, dlg),
            lang.hitch(this, function (error) { this._onActionError(sourceparams, error); this.StandbyStop(); }),
            false);
    }

    private _onUserInputDlgResponse_Custom(sourceparams: EntityViewTypes.ActionParameters, dlg: MdsLax<InstanceType<typeof GenericDialog>>, filterPanel: MdsLax<InstanceType<typeof FilterPanelWidget>>, buttonValue: string) {
        this._onUserInputDlgResponse(sourceparams, dlg, filterPanel, 1, buttonValue);
    }
    private _onUserInputDlgResponse(sourceparams: EntityViewTypes.ActionParameters,
        dlg: MdsLax<InstanceType<typeof GenericDialog>>,
        filterPanel: MdsLax<InstanceType<typeof FilterPanelWidget>>,
        dlgResult: number,
        customResult?: string) {

        if (dlgResult == 0) {
            // bei cancel oder close wird der Dialog einfach abgebrochen
            dlg.close(0, true);
            return;
        }
        this.StandbyStart(dlg.contentContainer);
        dlg.disableAllButtons();


        let data: EntityViewTypes.ActionRequestData = {
            actiontype: "ACTION",
            parameters: {
                ...sourceparams.additionalConfig,
                userselect: customResult ? customResult : dlgResult,
                filterpanelData: filterPanel ? filterPanel.getData() : null,
 //               actionName: sourceparams.actionName,
 },
            entityClass: sourceparams.entityClass,
            entityID: sourceparams.entityId,
            contextURL: location.href,
            contextName: this.contextName,
            functionname: sourceparams.callfunctionName
        };


        this.RequestManager.callfunction("Webtool_API_EntityView__ExecuteAction",
            data,
            lang.hitch(this, this._onUserInputResponse, sourceparams, dlg),
            lang.hitch(this, function (error) { this._onActionError(sourceparams, error); this.StandbyStop(); }),
            false);
    }

    private _onUserInputResponse(sourceparams: EntityViewTypes.ActionParameters, dlg: MdsLax<InstanceType<typeof GenericDialog>> | MdsLax<InstanceType<typeof SelectEntityDialog<any>>>, response: EntityViewTypes.ActionResponse<any>) {
        this.StandbyStop();

        if (dlg instanceof GenericDialog) {
            dlg.close(0, true);
        }

        sourceparams.actionType = "ACTION";

        this._onActionResponse(sourceparams, response);
    }

    private _onActionError(sourceparams: EntityViewTypes.ActionParameters, error: more.requestErrorMessage) {
        this.hourGlassEnd(sourceparams.node);

        this.showToast({
            title: sourceparams.node.innerText,
            message: error.Message,
            iconClass: toasterIcons.error,
            ID: sourceparams.entityId + sourceparams.entityClass + sourceparams.callfunctionName
        });
    }

    private _onAction_RequestEntityView(params: EntityViewTypes.ActionParameters, evt: MouseEvent) {
        if (evt?.stopPropagation) evt.stopPropagation();

        if (!this.entityListenerIDs) {
            this.entityListenerIDs = [];
            topic.subscribe("/Entity/Changed", lang.hitch(this, this._onSubscribedEntityChanged));
        }
        
        this.entityListenerIDs.push(params.entityId);

        let config: EntityViewTypes.setupConfig = {
            entityId: params.entityId,
            entityClass: params.entityClass,
            label: params.node.innerHTML,
            additionalParams: params.additionalConfig,
            contextName: params.contextName ? params.contextName : this.contextName,
            tabContainerName: this.tabContainerName,
            //nonInteractive: this.__isNonInteractiveEntityView == true // das ist jetzt die Frage, pauschal kann mans eigentlich nicht sagen...
        };
        topic.subscribe("/Entity/Opened/" + config.entityId, lang.hitch(this, this._onSubEntityOpened));
        EntityHelpers.openEntityView(config);
        //topic.publish("/Entity/OpenView", config);
    }

    private _onSubEntityOpened(view: _EntityViewMixin<any>) {
        if (view) {
            view.on("change", lang.hitch(this, this._onChanged_Subview));
        }
    }
    private _subviewchangeTimeout;
    private _onChanged_Subview() {
        

        if (this._subviewchangeTimeout) {
            clearTimeout(this._subviewchangeTimeout);
        }

        this._subviewchangeTimeout = setTimeout(lang.hitch(this, function () { this.reload(); this.emit("change"); }), 300);
    }
    private entityListenerIDs: Array<string>

    private _onSubscribedEntityChanged(params: { changedEntityID: string }) {
        if (!this.entityListenerIDs) return;
        if (this.entityListenerIDs.indexOf(params.changedEntityID) != -1) this.reload();
    }

    private _handlePageStacks() {

        let targetNames = ["mcps"];

        for (let i = 0; i < targetNames.length; i++) {

            let elements = this.contentContainer.getElementsByTagName(targetNames[i]);
            let count = 0;
            while (elements.length > 0) {
                let elem = elements[0];
                count++;

                let newContainer = this.UiModder.domConstruct.create("div", {}, elem, "after");

                let label = elem.attributes.getNamedItem("data-label")?.value;

                if (label) {
                    label = TranslationHelpers.tryTranslate(label);
                    this.UiModder.domConstruct.create("h5", { innerHTML: label }, newContainer);

                }

                let pagestack = new PageStack();
                pagestack.placeAt(newContainer);


                let pages = elem.getElementsByTagName("page");
                let pageCount = 0;
                while(pages.length) {

                    let pageElement = pages[0] as HTMLElement;
                    let pagelabel = pageElement.attributes.getNamedItem("data-label")?.value;
                    pagelabel = TranslationHelpers.tryTranslate(pagelabel)

                    let psPage = pagestack.addPage(pageElement, {
                        label: pagelabel,
                        name: pageCount.toString(),
                        iconclass: pageElement.attributes.getNamedItem("data-icon")?.value,
                        coloration: pageElement.attributes.getNamedItem("data-bg-color")?.value,
                    });

                    if (psPage?.contentNode) {
                        // üblicherweise schachtelt man in den Pagestack wieder einzelne Entityviews, aber fix ist das nicht
                        // ausm Backend kann auch einfach plain HTML kommen. eindeutige schöne Erkennung gibt es nicht.
                        let entityviewElements = psPage.contentNode.getElementsByTagName("flex"); // ist eh das wichtigste. wenns das gibt, dann brauchen wir display flex etc und sind sehr sicher ein Entityview
                        if (!entityviewElements.length) entityviewElements = psPage.contentNode.getElementsByTagName("box");
                        if (!entityviewElements.length) entityviewElements = psPage.contentNode.getElementsByTagName("mccb");
                        if (entityviewElements.length) {
                            this.UiModder.domClass.add(psPage.contentNode, "entityView");
                        }
                    }
                    pageCount++;
                }

                this.UiModder.domConstruct.destroy(elem);

                if (count > 999) break;
            }
        }
    }
    private _handleCheckboxes() {

        let elements = this.contentContainer.getElementsByTagName("mccb");
        let count = 0;

        while (count < elements.length) {
            let elem = elements[count] as HTMLElement;
            count++;

            let label = elem.getElementsByTagName("label")[0];
            let value = elem.getAttribute("data-value") == 'true';

            if (this.canTranslate(label.innerHTML)) label.innerHTML = this.translate(label.innerHTML);

            let isInteractive = false;
            let isReadonly = elem.getAttribute("data-readonly") != 'false'



            let checkboxContainer = elem;// this.UiModder.domConstruct.create("div", { className: "c" }, elem, "replace");


            // prüfen ob die Checkbox ihrerseits in einem Button verschachtelt ist! dann kommt Interaktivität dazu!
            if (checkboxContainer.parentElement && checkboxContainer.parentElement.tagName.toLowerCase() == "button" && checkboxContainer.parentElement.className.indexOf("entityViewAction") != -1) {
                // der Button sollte also unsichtbar werden, aber normal registriert als Klick. Wir müssen den Klick der Checkbox aber weiterleiten

                let cb = new CheckBox();
                cb.setValue(value, true);
                cb.setLabel(label.innerHTML);

                cb.setType("toggle");

                this.UiModder.domConstruct.destroy(label);

                cb.placeAt(checkboxContainer);

                let button = checkboxContainer.parentElement;

                cb.on("change", lang.hitch(this, this._onAction_Checkbox, cb, button));

                this.UiModder.domConstruct.place(checkboxContainer, button, "after")

                this.UiModder.domClass.toggle(checkboxContainer, "hoverBright", !isReadonly);

                cb.setReadonly(isReadonly);

                this.UiModder.domClass.add(button, "hidden");
                button.setAttribute("data-targetCb", cb.id);

            } else {
                this.UiModder.domClass.add(checkboxContainer, "readonly");
                let iconContainer = this.UiModder.domConstruct.create("div", {}, label, "before");

                let iconYes = this.createFontawesomeIcon("fas fa-check yes");
                let iconNo = this.createFontawesomeIcon("fas fa-times no");

                this.UiModder.domConstruct.place(iconNo, iconContainer);
                this.UiModder.domConstruct.place(iconYes, iconContainer);
            }



            if (count > 999) break;
        }

    }

    private _onAction_Checkbox(cb: MdsLax<InstanceType<typeof CheckBox>>, button: HTMLElement) {
        // das normale Klickevent ausführen: am Button sind alle Parameter registriert für die eigentliche Action
        button.click();
    }

    private _handleExpanderContent() {

        this._expanderNameIndex = {};


        let targetNames = ["expl", "expm", "exps"];
        let targetSizes: Array<"large" | "medium" | "small"> = ["large", "medium", "small"];


        for (let i = 0; i < targetNames.length; i++) {

            let elements = this.contentContainer.getElementsByTagName(targetNames[i]);
            let count = 0;
            while (elements.length > 0) {
                let elem = elements[0];
                count++;

                
                
                let label = elem.getElementsByTagName("label")[0];
                let content = elem.getElementsByTagName("content")[0];

                if (this.canTranslate(label.innerHTML)) label.innerHTML = this.translate(label.innerHTML);

                let expansionState = elem.getAttribute("data-expand");
                let isExpanded = expansionState === "true";

                let marking: ExpandableSectionMarkings = ExpandableSectionMarkings.default;
                let markingAttr = elem.getAttribute("data-marking");
                if (markingAttr) {
                    marking = markingAttr as any;
                }

                //let parent = elem.closest("[data-entityview-expander-name]");

                let expander = new ExpandableSection();
                expander.setup(content?.innerHTML,
                    label.innerText,
                    targetSizes[i],
                    null,
                    null,
                    isExpanded,
                    marking
                );

                // Versuchen einen eindeutigen Expandernamen zu generieren

                let expanderName = label.innerText; // was Besseres haben wir nicht. Die Beschriftung wird sich ja wahrscheinlich nicht ständig ändern
                let index = this._expanderNameIndex[expanderName];
                if (!index) index = -1;
                index++;
                this._expanderNameIndex[expanderName] = index;
                expanderName = expanderName + "_" + index;

                expander.domNode.setAttribute("data-entityview-expander-name", expanderName);

                let reg = this._expanderStateMap[expanderName];
                if (!reg) {
                    reg = {
                        expanded: isExpanded,
                        //followingNeighbor: null,
                        //previousNeighbor: null,
                        name: expanderName,
                        //    nested: {}                        
                    }

                    //if (previousExpanderState) {
                    //    reg.previousNeighbor = previousExpanderState.name;
                    //    previousExpanderState.followingNeighbor = reg.name;
                    //}

                    //if (parent) {
                    //    let name = parent.getAttribute("data-entityview-expander-name");
                    //    if (name) reg.parent = name;
                    //}

                    this._expanderStateMap[expanderName] = reg;
                } else {
                    debugger;
                    expander.toggleExpand(reg.expanded, false, true);
                }
                

                //if (this._localStorageSettings?.expanderStates) {
                //    let storedSetting = this._localStorageSettings.expanderStates[expanderName];

                //    if (storedSetting) {
                //        expander.toggleExpand(storedSetting.expanded, false, true);
                //    }

                //}

                let newContainer = this.UiModder.domConstruct.create("div", {}, elem, "replace");
                expander.placeAt(newContainer);


                expander.on("expand", lang.hitch(this, this._onExpanderToggle, expanderName, true));
                expander.on("collapse", lang.hitch(this, this._onExpanderToggle, expanderName, false));


                if (count > 999) break;
            }
        }

    }

    private _onExpanderToggle(expanderName: string, isExpanded: boolean) {

        let localState = this._expanderStateMap[expanderName];
        if (localState) {
            localState.expanded = isExpanded;
            //if (this._localStorageSettings?.expanderStates) {



            //        this._localStorageSettings.expanderStates[expanderName] = localState;

            //        this._saveUserSettingsToLocalStorage();
            //    }
            //}
        }

    }

    private _handleButtonsTimeout: any = null;
    private _handleButtons() {
        if (this._handleButtonsTimeout) {
            clearTimeout(this._handleButtonsTimeout);
        }

        this._handleButtonsTimeout = setTimeout(lang.hitch(this, this.__handleButtons), 150);
    }

    requestContextButton(config: Tabbing.ContextActionButtonRequest): Tabbing.ContextActionButtonDescriptor {
        if (this.isStandalone) {
            this.addButton(config.name,
                config.label,
                config.callback,
                config.tooltip,
                config.styleClass,
                config.iconClass,
                false,
                null,
                config.enabled);
        } else {
            return super.requestContextButton.apply(this, arguments as any);
        }
    }
    requestContextButtonRemove(name: string):void {
        if (this.isStandalone) {

        } else {
            return super.requestContextButtonRemove.apply(this, arguments as any);
        }
    }
    requestContextButtonEnable(name: string, bEnable?: boolean):void {
        if (this.isStandalone) {

        } else {
            return super.requestContextButtonEnable.apply(this, arguments as any);
        }
    }
      requestContextButtonDisable(name: string, bDisable?: boolean):void {
        if (this.isStandalone) {

        } else {
            return super.requestContextButtonDisable.apply(this, arguments as any);
        }
    }

    private __handleButtons(reset?: boolean) {
        this._handleButtonsTimeout = null;

        if (this._destroyed == true) return

        if (reset == true) {
            // alle entfernen aus Registry etc
            this.requestContextButtonRemove("edit");
            this.requestContextButtonRemove("delete");
            this.requestContextButtonRemove("reload");

        }

        if (this.useDefaultButtons != true) return;

        this.createDefaultButton("reload", lang.hitch(this, this.reload));

        if (this.editingAllowed) {
            this.createDefaultButton("edit", lang.hitch(this, this._onRequestEditor, this.entityID, this.entity));

            this.enableButton("edit", this.editingEnabled);
        } else {
            this.requestContextButtonRemove("edit");
        }

        if (this.cloningAllowed) {
            this.createDefaultButton("clone", lang.hitch(this, this.onClone, this.entityID, this.entity));

            this.enableButton("clone", this.cloningEnabled);

        } else {
            this.requestContextButtonRemove("clone");
        }

        if (this.deletingAllowed) {
            this.createDefaultButton("deleteWithConfirmationDlg", lang.hitch(this, this._onDelete, this.entityID, this.entity));

            this.enableButton("delete", this.deletingEnabled);
        } else {
            this.requestContextButtonRemove("delete");
        }


    }

    private _onDelete() {
        if (this.entityID && this.deletingAllowed && this.config.deleteOptions?.deleteEntityFunctionname) {
            this.StandbyStart();
            this.RequestManager.callfunction(
                this.config.deleteOptions.deleteEntityFunctionname,
                this.getRequestData(),
                lang.hitch(this, this._afterDelete),
                lang.hitch(this, this._onDeleteError),
                true
            );
        }
    }
    private testButtonAvailability(type: EntityViewTypes.privilegeType) {
        if (!type) return;


        if (this.entityID && this.deletingAllowed && this.config.deleteOptions?.deleteEntityFunctionname) {
            window.standbyManager.addSpinner();

            let data = {
                data: this.getRequestData(),
                type: type
            };

            this.RequestManager.callfunction(
                "Webtool_API_EntityView__GetButtonState",
                data,
                lang.hitch(this, this._onTestButtonAvailability),
                lang.hitch(this, this._onTestButtonAvailabilityError, type),
                true
            );
        }
    }

    private _onTestButtonAvailabilityError(type: EntityViewTypes.privilegeType, error: more.requestErrorMessage) {
        this._onTestButtonAvailability({
            type: type,
            result: false
        });

        alert(error.Message);
    }
    private _onTestButtonAvailability(response: { type: EntityViewTypes.privilegeType, result: boolean }) {
        window.standbyManager.removeSpinner();

        if (response?.type) {
            let result = response.result === true;

            switch (response.type) {
                case "delete":
                    this.deletingEnabled = result;
                    break;

                case "edit":
                    this.editingEnabled = result;
                    break;

                case "create":
                    break;

                case "clone":
                    this.cloningEnabled = result;
            }

            this._handleButtons();
        }
    }

    private _afterDelete(result) {
        this.StandbyStop();

        this.emit("deleted");
        this.emit("entityDeleted");

        //this.emit("change");

        this.afterDelete();

        this.close();
    }
    private _onDeleteError(error: more.requestErrorMessage) {
        this.StandbyStop();
        alert(error.Message);
    }

    showAtNode(entityId?: string,
        heading?: string,
        node?: HTMLElement,
    useStandaloneFrame?: boolean) {

        if (!node) return;

        this.isStandalone = true;

        if (typeof (useStandaloneFrame) == "boolean") this.useStandaloneFrame = useStandaloneFrame;

        this._setup(entityId, heading);

        //if (!this.entityID) return;


        if (this.tabContainerName && this.currentDisplayMode == "tab") {
            this.closeTab();
        }

        if (this.dlg && this.currentDisplayMode == "dlg") {
            this.dlg.close(-1, true);
            this.dlg = null;
        }

        this.placeAt(node);


        this.isActive = true;
        this.currentDisplayMode = "node";
        this._continueShow();
    }
    //setup(config: EnityFrameOptons<X>, heading?: string, entityId?: string) {
    /**
     * Entity anzeigen in modalem Dialog
     * @param entityId
     * @param heading
     * @param tabContainerName Falls angegeben, kann der Benutzer das Entity jederzeit per Klick in den Tabcontainer umsiedeln
     */
    showAsDlg(entityId?: string,
        heading?: string,
        tabContainerName?: string,
        tabGroupLabel?: string) {

        if (this.tabContainerName && this.currentDisplayMode == "tab") {
            this.closeTab();
        }

        this.isStandalone = false;


        this._setup(entityId, heading, tabGroupLabel);

        if (!this.entityID) return;

        if (tabContainerName) this.tabContainerName = tabContainerName;


        if (!this.dlg) {
            this.dlg = new GenericDialog();

            this.dlg.closeOnEscape = true;

            this.dlg.on("closed", lang.hitch(this, this._onDlgClosed));
        }
        if (this.dlg) {

            this.dlg.show(
                this,
                heading ? heading : "General_Loading",
                null, null,
                "close",
                lang.hitch(this, this._onDlgResult)
            );

            if (tabContainerName) {
                this.tabContainerName = tabContainerName;
                this.dlg.addButton("tab-" + this.internalName,
                    "",
                    lang.hitch(this, this._moveToTab),
                    null,
                    null,
                    "fas fa-external-link-alt",
                    false,
                    "top first",
                    true);
            }

            this.isActive = true;
            this.currentDisplayMode = "dlg";
            this._continueShow();
        }
    }

    protected tryMoveToTab(bHandleOverflow = true): boolean {
        this._moveToTab(bHandleOverflow);

        return this.isEmbeddedInTab;
    }
    private _moveToTab(bHandleOverflow = true) {
        if (this.currentDisplayMode == "dlg" && this.dlg) {
            //this.dlg.destroyOnClose = false;

            this.showAsTab(null, null, null, null, bHandleOverflow);

            //this.__handleButtons(true);  // warum? im showAsTab kommt man eh auch dahin
        }
    }

    showAsTab(entityId?: string,
        label?: string,
        tabContainerName?: string,
        groupHeading?: string,
        bHandleOverflow = true) {

        this._setup(entityId, label, groupHeading);

        label = this.title;

        if (!!this.tabContainerName && !!tabContainerName && this.tabContainerName != tabContainerName) {
            if (this.currentDisplayMode == "tab") {
                this.closeTab();
            }
        }

        if (this.dlg && this.currentDisplayMode == "dlg") {
            this.dlg.close(-1, true);
            this.dlg = null;
        }

        if (tabContainerName) this.tabContainerName = tabContainerName;

        if (this.tabContainerName) {
            if (this.activateTab(this.internalName, this.tabContainerName) == true) {
                return;
            } else {
                //this.embedAsTab(this.tabContainerName);
                this.createNewTabbedContent({

                    enableClosing: true,
                    label: label,
                    name: this.internalName,
                    widget: this,
                    coloration: null,
                    iconclass: null,
                    groupLabel: this.groupLabel,
                    sidebarEntryName: this.internalName,
                    targetContainerName: this.tabContainerName
                }, true, true);

                this.isActive = true;

                if (this.isEmbeddedInTab) {
                    this.UiModder.domClass.add(this.domNode, "tabbed w3-content");
                }

                this._continueShow();
            }

        }

        if (this.isEmbeddedInTab) {
            this.requestTabSwitchGlobal(this.internalName);
            this.currentDisplayMode = "tab";
            this.isActive = true;
        }
    }

    private frame_TopContainer: HTMLElement;
    private frame_BottomContainer: HTMLElement;
    private frame_Heading: HTMLElement;
    private frame_ActionBar: HTMLElement;

    private _destroyFrameContainer() {
        if (this.frame_TopContainer) {
            this.UiModder.domConstruct.destroy(this.frame_TopContainer);
        }
        if (this.frame_BottomContainer) {
            this.UiModder.domConstruct.destroy(this.frame_BottomContainer);
        }

        this.frame_BottomContainer = null;
        this.frame_TopContainer = null;
    }
    private _createFrameHeading(heading: string) {
        if (this.frame_Heading) this.UiModder.domConstruct.destroy(this.frame_Heading);
        if (this.frame_TopContainer) {
            if (this.title) {
                this.frame_Heading = this.UiModder.domConstruct.create("h5", { innerHTML: this.title }, this.frame_TopContainer, "first");
            }
            this.hideNode(this.frame_TopContainer, !this.isStandalone);
        }

    }
    private _setupFrameContainers() {
        this._destroyFrameContainer();

        this.UiModder.domClass.toggle(this.domNode, "standalone", this.isStandalone);
        this.UiModder.domClass.toggle(this.domNode, "displayFrame", this.isStandalone && this.useStandaloneFrame);
        if (!this.isStandalone) return;

        let topContainer = this.UiModder.domConstruct.create("div", { className: "w3-hide", id: "frameContainer_Top" }, this.domNode, "first");
        this.frame_ActionBar = this.UiModder.domConstruct.create("div", { className: "w3-hide", id: "frameActionbar" }, topContainer, "last");
        let bottomContainer = this.UiModder.domConstruct.create("div", { className: "w3-hide", id: "frameContainer_Bottom" }, this.domNode, "last");

        if (this.title) {
            this._createFrameHeading(this.title);
            this.hideNode(topContainer, false);
        }

        this.frame_TopContainer = topContainer;
        this.frame_BottomContainer = bottomContainer;
    }

    private _continueShow() {

        if (!this.viewData && !this._loadRequest && this.entityID) {
            this.loadViewData();
        }

        let previouslyAddedButtons = this._buttonConfigs;
        this._buttonConfigs = [];

        for (let entry of previouslyAddedButtons) {
            this.addButton(entry.internalName,
                entry.label,
                entry.callback,
                entry.tooltip,
                entry.styleClass,
                entry.iconClass,
                entry.bCloseOnClick,
                entry.position,
                entry.enabled);
        }

        for (let entry of this._buttonConfigsQueue) {
            this.addButton(entry.internalName,
                entry.label,
                entry.callback,
                entry.tooltip,
                entry.styleClass,
                entry.iconClass,
                entry.bCloseOnClick,
                entry.position,
                entry.enabled);
        }


        this.onShow();
        this.__handleButtons(true);

    }


    // Tabcontainer-Mixin:
    _onActivated() {

    }

    close() {
        if (!this.isActive) return;

        this.isActive = false;

        this.onClose();

        if (this.dlg && this.dlg.is_active == true) {
            this.dlg.close(-1);
            this.dlg = null;
        }
        if (this.isEmbeddedInTab && !this._destroyed) this.closeTab();

        this.emit("closed"); this.createDefaultButton
    }

    /**
     * Einen kontextbezogenen NEU-Button erstellen.
     * Label und Farbe werden ignortiert.
     * Die Konfiguration wird im Hintergrund so standardisiert, dass das Label gleichbleibend ist.
     * @param requestData Konfigurationsparameter inklusive Beschriftung und Callback
     * @param initialEnabledState
     */
    protected createDefaultButton(type: Tabbing.DefaultButtonName, callback: Function,
        initialEnabledState: boolean = true) {

        if (!this.isStandalone) {
            super.createDefaultButton.apply(this, arguments as any);
            return;
        }

        //if (!this.isEmbeddedInTab) return;

        if (type == "deleteWithConfirmationDlg") {
            // dann packen wir das Callback in eine Standardmethode mit GenericDlg:
            let newCallback = lang.hitch(this, this._defaultDeleteCallbackDlg, callback, null);
            callback = newCallback;
            type = "delete";
        }

        if (type == "copy") type = "clone";

        if (this._createdDefaultButtons.indexOf(type) != -1) return;


        let permanent = false;
        let label = "";
        let styleclass = null;
        let iconClass: string = "";
        let icon: HTMLElement = null;
        let placement: Tabbing.ButtonPlacement = "top";
        let order = 99;
        switch (type) {
            case "new":
                permanent = false;
                iconClass = "fas fa-plus-circle";
                label = this.translate("General_CreateNew");
                order = 0;
                break;

            case "save":
                permanent = false;
                iconClass = "fas fa-save";
                label = this.translate("General_Save");
                placement = "actionbar";
                order = 10;
                break;

            case "rollback":
                permanent = false;
                iconClass = "fas fa-undo";
                label = this.translate("General_Rollback");
                placement = "actionbar";
                order = 12;
                break;

            case "clone":
                //case "copy":
                permanent = false;
                iconClass = "fas fa-clone";
                label = this.translate("General_Copy");
                placement = "actionbar";
                order = 15;
                break;
            case "delete":
                permanent = false;
                iconClass = "fas fa-trash warningTXT";
                label = this.translate("General_Delete");
                placement = "actionmenu";
                order = 999;
                break;
            case "reload":
                permanent = false;
                iconClass = "fas fa-sync";
                label = this.translate("General_Refresh");
                order = 20;
                break;
            case "edit":
                permanent = false;
                iconClass = "fas fa-edit";
                label = this.translate("General_Edit");
                order = 30;
                styleclass = "accentBG";
                placement = "actionbar";
                callback = lang.hitch(this, this._onClickEditButton, callback);

                break;
            case "rollback":
                permanent = false;
                iconClass = "fas fa-reply"
                label = this.translate("General_Rollback");
                order = 40;
                break;
            case "deactivate":
                permanent = false;
                iconClass = "fas fa-power-off"
                label = this.translate("General_SetAsInactive");
                placement = "actionmenu";
                order = 998;
                // den anderen suchen und rauswerfen:
                this.requestContextButtonRemove("activate");
                break;
            case "activate":
                permanent = false;
                iconClass = "fas fa-power-off"
                label = this.translate("General_SetAsActive");
                placement = "actionmenu";
                order = 998;
                // den anderen suchen und rauswerfen:
                this.requestContextButtonRemove("deactivate");
                break;
            default:

                return;
                break;
        }
        let config: Tabbing.ContextActionButtonRequest = {
            callback: callback,
            permanent: permanent,
            placement: placement,
            label: label,
            iconClass: iconClass,
            styleClass: styleclass,
            enabled: initialEnabledState,
            order: order
        };

        this._createdDefaultButtons.push(type);
        this.requestContextButton(config)

    }

    removeButton(internalName: string) {
        let iB = this.getIndexOfButtonRegistry(internalName);

        if (iB != -1) {
            if (this.isEmbeddedInTab) {
                this.requestContextButtonRemove(internalName);
            }

            if (this.isStandalone) {
                // todo - gibts nicht
            }

            if (this.dlg && !this.dlg._destroyed) {
                this.dlg.removeButton(
                    internalName
                );
            }


            this._buttonConfigs.splice(iB, 1);
        }

    }

    disableButton(internalName: string) {
        this.enableButton(internalName, false);
    }
    enableButton(internalName: string, bEnable: boolean = true) {
        if (this.isEmbeddedInTab) {
            this.requestContextButtonEnable(internalName, bEnable);
        }

        if (this.isStandalone) {
            let index = this.getIndexOfButtonRegistry(internalName);
            if (index < 0) return;
            let button = this._buttonConfigs[index];

        }

        if (this.dlg && !this.dlg._destroyed) {
            this.dlg.enableButton(internalName, bEnable );
        }
    }

    addButtonMenuEx(buttonMenuConfig: uiFrameTypes.ButtonGroupConfig) {
        this.addButtonMenu(
            buttonMenuConfig.internalName,
            buttonMenuConfig.label,
            buttonMenuConfig.iconClass,
            buttonMenuConfig.bIsGroupNextLevel,
            buttonMenuConfig.parentGroupName
        )
    }

    addButtonMenu(
        name: string,
        label?: string,
        iconClass?: string,
        bIsGroupNextLevel?: boolean,
        parentGroupName?: string
    ) {
        if ((this.currentDisplayMode === "dlg" && this.dlg && !this.dlg._destroyed)) {
            this.dlg.addButtonMenu(name, label, iconClass, bIsGroupNextLevel, parentGroupName);
        }
        else if (this.currentDisplayMode === "tab") {
            this.createMenuGroup({
                label: label,
                name: name,
                iconClass: iconClass,
                hasNextLevel: bIsGroupNextLevel,
                parentGroupName: parentGroupName
            });
        }
    }

    addButtonEx(buttonConfig: uiFrameTypes.ButtonConfig) {
        this.addButton(
            buttonConfig.internalName,
            buttonConfig.label,
            buttonConfig.callback,
            buttonConfig.tooltip,
            buttonConfig.styleClass,
            buttonConfig.iconClass,
            buttonConfig.bCloseOnClick,
            buttonConfig.position == "primary" ? "last" : "left first",
            buttonConfig.enabled,
            buttonConfig.hasNextLevel,
            buttonConfig.hasPreviousLevel,
            buttonConfig.groupname
        );
    }

    addButton(
        internalName: string,
        label: string,
        callback: Function,
        tooltip?: string,
        styleClass?: string,
        iconClass?: string,
        bCloseOnClick?: boolean,
        position?: "first" | "last" | "left first" | "left last" | "top first" | "top last" | number,
        enabled?: boolean,
        hasNextLevel?: boolean,
        hasPreviousLevel?: boolean,
        groupname?: string
    ) {
        let i = this.getIndexOfButtonQueue(internalName);
        if (i != -1) this._buttonConfigsQueue.splice(i, 1);

        this.removeButton(internalName);

        let buttonConfig: EntityViewTypes.ButtonConfig = {
            internalName: internalName,
            callback: callback,
            label: label,
            tooltip: tooltip,
            bCloseOnClick: bCloseOnClick,
            enabled: enabled,
            iconClass: iconClass,
            position: position,
            styleClass: styleClass,
            hasNextLevel: hasNextLevel,
            hasPreviousLevel: hasPreviousLevel,
            groupname: groupname
        };

        this._buttonConfigs.push(buttonConfig);
        if (this.isStandalone) {

            let button = this.UiModder.domConstruct.create("button", {
                "innerHTML": label,
                "className": "contextButton buttonBase hoverBright w3-disabled"
            }, this.frame_ActionBar,
                position == "first" ? position : "last");

            buttonConfig.node = button;

            if (styleClass) this.UiModder.domClass.add(button, styleClass);
            if (iconClass) {
                let icon = this.createFontawesomeIcon(iconClass);
                this.UiModder.domConstruct.place(icon, button, "first");
            }

            on(button, "click", lang.hitch(this, this._onClickContextButton, buttonConfig))

            this.enableButton(internalName, enabled && typeof (callback) == "function");

            this.hideNode(this.frame_ActionBar, this._buttonConfigs.length == 0);
        }
        else if (this.isEmbeddedInTab) {
            let tabPlacement: Tabbing.ButtonPlacement = "actionbar";
            switch (position) {

                case "top first":
                case "top last":
                    tabPlacement = "actionmenu";
                    break;
            }
            this.requestContextButton({
                callback: callback,
                label: label,
                name: internalName,
                iconClass: iconClass,
                heading: null,
                permanent: false,
                enabled: enabled,
                coloration: null,
                order: null,
                styleClass: styleClass,
                placement: tabPlacement,
                groupName: groupname,
                tooltip: tooltip
                // für placement gibt es keine gscheite Übersetzung...
            });
        } else if (this.dlg && !this.dlg._destroyed) {
            this.dlg.addButton(
                internalName,
                label,
                callback,
                tooltip,
                styleClass,
                iconClass,
                bCloseOnClick,
                position,
                enabled,
                hasNextLevel,
                hasPreviousLevel,
                groupname
            );
        } else {
            this._buttonConfigsQueue.push({
                callback: callback,
                internalName: internalName,
                label: label,
                bCloseOnClick: bCloseOnClick,
                enabled: enabled,
                iconClass: iconClass,
                position: position,
                styleClass: styleClass,
                tooltip: tooltip
            });

        }
    }

    private _onClickContextButton(config: EntityViewTypes.ButtonConfig, evt: MouseEvent) {
        if (!config?.enabled) return;
        if (config.callback) config.callback();
    }

    private getIndexOfButtonQueue(buttonName: string) {
        let index = -1;
        for (let entry of this._buttonConfigsQueue) {
            index++;
            if (entry.internalName == buttonName) {
                return index;
            }
        }

        return -1;
    }
    private getIndexOfButtonRegistry(buttonName: string) {
        let index = -1;
        for (let entry of this._buttonConfigs) {
            index++;
            if (entry.internalName == buttonName) {
                return index;
            }
        }

        return -1;
    }

    private _onLoadPrivilege(type: EntityViewTypes.privilegeType, callback, result: boolean) {

        window.standbyManager.removeSpinner();

        switch (type) {
            case "delete":
                this.deletingAllowed = result;
                if (this.deletingAllowed == true) this.testButtonAvailability(type);
                break;

            case "edit":
                this.editingAllowed = result;
                this.editingEnabled = result;
                break;

            case "create":
                break;

            case "clone":
                this.cloningAllowed = result;
                this.cloningEnabled = result;// !!this.entity;
        }

        if (callback) callback();

        this._handleButtons();
    }

    protected checkPrivileges(callback?) {
        this.editingAllowed = false;
        this.cloningAllowed = false;
        this.deletingAllowed = false;



        let checkEditing: boolean = true;
        if (this.config?.editOptions) {
            if (this.config?.editOptions.featurePathEdit) checkEditing = this.hasFeature(this.config.editOptions.featurePathEdit);
        }

        let checkDeleting: boolean = true;
        if (this.config?.deleteOptions) {
            if (this.config?.deleteOptions.featurePathDelete) checkDeleting = this.hasFeature(this.config.deleteOptions.featurePathDelete);
        }

        let checkCloning: boolean = true;
        if (this.config?.cloneOptions) {
            if (this.config?.cloneOptions.featurePathClone) checkCloning = this.hasFeature(this.config.cloneOptions.featurePathClone);
        }

        this._handleButtons();

        if (this.entity || this.entityID) {
            let entity: more.EntityAPIResult = this.entity as any;
            if (!entity) {
                entity = {
                    ID: this.entityID,
                    Classname: this.config.entityClassname
                };
            }
            if (this.config.editOptions) {
                if (this.config.editOptions.userroleEdit && checkEditing) {
                    window.standbyManager.addSpinner();
                    this.hasUserRole(this.config.editOptions.userroleEdit, lang.hitch(this, this._onLoadPrivilege, "edit", callback), entity);
                }
            }
            if (this.config.cloneOptions) {
                if (this.config.cloneOptions.userroleClone && checkCloning) {
                    window.standbyManager.addSpinner();
                    this.hasUserRole(this.config.cloneOptions.userroleClone, lang.hitch(this, this._onLoadPrivilege, "clone", callback), entity);
                }
            }

            if (this.config.deleteOptions) {
                if (this.config.deleteOptions.userroleDelete && checkDeleting) {
                    window.standbyManager.addSpinner();
                    this.hasUserRole(this.config.deleteOptions.userroleDelete, lang.hitch(this, this._onLoadPrivilege, "delete", callback), entity);
                }
            }
        }

    }

    _onEmbedding() {
        super._onEmbedding.apply(this, arguments as any);

        if (this.isEmbeddedInTab == true && this.isEditing == true) {
            this.openEditorTab = this.getExistingTab(this.entityID, this.tabContainerName);
        }

    }

    protected onDestroy() {

    }

    destroy(): void {

        try {
            this.RequestManager.cancelRunningRequests(); // is glaubich eh schon in widgetbase?

            this.onDestroy();
        } catch (ex) {

        }
        super.destroy.apply(this, arguments as any);
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this._buttonConfigsQueue = [];
        this._buttonConfigs = [];

        this._expanderStateMap = {};


        this._knownContextButtons = [];

        this.useStandbyManager = true;


        // für den sehr seltenen Fall dass die entityview mal einzeln gepatcht wird und die anderen Skripts das neue Interface
        // nicht nutzen.... KLUB husthust. Die alten Options umformen in neue, dann passt das:
        try {
            let legacyOptions = this.config as EnityFrameOptionsLEGACY;
            if (legacyOptions.featurePathClone ||
                legacyOptions.userroleClone ||
                legacyOptions.featurePathDelete ||
                legacyOptions.userroleDelete ||
                legacyOptions.userroleEdit ||
                legacyOptions.featurePathEdit) {
                if (!this.config.cloneOptions) this.config.cloneOptions = {};
                if (!this.config.editOptions) this.config.editOptions = {} as any;
                if (!this.config.deleteOptions) this.config.deleteOptions = {};

                this.config.editOptions.featurePathEdit = legacyOptions.featurePathEdit;
                this.config.editOptions.userroleEdit = legacyOptions.userroleEdit;

                this.config.cloneOptions.featurePathClone = legacyOptions.featurePathClone;
                this.config.cloneOptions.userroleClone = legacyOptions.userroleClone;

                this.config.deleteOptions.featurePathDelete = legacyOptions.featurePathDelete;
                this.config.deleteOptions.userroleDelete = legacyOptions.userroleDelete;

            }
        } catch (ex) {

        }

        if (this.config?.entityClassname) {
            this.UiModder.domConstruct.empty(this.contentContainer);
            this.UiModder.domClass.toggle(this.domNode, this.config.entityClassname);
        }

        // Standard-API für Request falls nicht in Config:
        if (this.config && !this.config.requestDataFunctionname) {
            this.config.requestDataFunctionname = "Webtool_API_EntityView__GetEntityViewData";
        }
        if (this.config && this.config.deleteOptions && !this.config.deleteOptions.deleteEntityFunctionname) {
            this.config.deleteOptions.deleteEntityFunctionname = "Webtool_API_EntityView__DeleteEntity";
        }

        if (this.config && !this.config.idProperty) {
            this.config.idProperty = "ID";
        }



    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(_EntityViewMixin);
